export const Benefits = {
  PLATINUM: {
    webBenefits: [
      {
        id: 1,
        desc: 'Unlimited service visits for breakdown',
        icon: 'breakdown',
      },
      {
        id: 2,
        desc: '4 service visits for maintenance',
        icon: 'service',
      },
      {
        id: 3,
        desc: 'Annual all filter replacement',
        icon: 'consumables',
      },
      {
        id: 4,
        desc: 'Free replacement of spare parts',
        icon: 'spares',
      },
    ],
    mobileBenefits: {
      RO: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visits every year to get adequate cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '4',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: {
            title: 'Annual filter replacement**',
            subtitle: 'RO Membrane',
          },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: 'Free',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Sediment Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: 'Free',
        },
      ],
      UV: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visits every year to get adequate cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '4',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: {
            title: 'Annual filter replacement**',
            subtitle: 'Sediment Filter',
          },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: 'Free',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'UV System Check' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: 'Free',
        },
      ],
    },
    cartBenefits: [
      {
        id: 'benefit_1',
        icon: 'breakdown',
        title: 'Unlimited service visits for breakdown',
        description: 'Use Eureka Forbes App/Website to book service request for emergency',
      },
      // {
      //   id: 'benefit_2',
      //   icon: 'service',
      //   title: '4 service visits for maintenance',
      //   description:
      //     'Get 4 free service visits every year to ensure Intensive cleaning and maintenance of water purifier and filters',
      // },
      {
        id: 'benefit_3',
        icon: 'consumables',
        title: 'Annual all filter replacement',
        description:
          'All filters get replaced free of charge, every year for continued purity assurance',
      },
      {
        id: 'benefit_4',
        icon: 'spares',
        title: 'Replacement of spare parts',
        description:
          'On breakdown, damaged parts shall be replaced with new spare parts free of charge',
      },
      {
        id: 'benefit_5',
        icon: 'peaceOfMind',
        title: 'Assurance of quality',
        description:
          'Get genuine Eureka Forbes filters/spare parts and stay safe from fake filters',
      },
    ],
  },
  GOLD: {
    webBenefits: [
      {
        id: 1,
        desc: 'Unlimited service visits for breakdown',
        icon: 'breakdown',
      },
      {
        id: 2,
        desc: '3 service visits for maintenance',
        icon: 'service',
      },
      {
        id: 3,
        desc: 'Annual all filter replacement',
        icon: 'consumables',
      },
      {
        id: 4,
        desc: 'Free replacement of spare parts',
        icon: 'spares',
      },
    ],
    mobileBenefits: {
      RO: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visits every year to ensure comprehensive cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '3',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: { title: 'Annual filter replacement**', subtitle: 'RO Membrane' },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: 'Free',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Sediment Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: 'Free',
        },
      ],
      UV: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visits every year to ensure comprehensive cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '3',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: { title: 'Annual filter replacement**', subtitle: 'Sediment Filter' },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: 'Free',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'UV System Check' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: 'Free',
        },
      ],
    },
    cartBenefits: [
      {
        id: 'benefit_1',
        icon: 'breakdown',
        title: 'Unlimited service visits for breakdown',
        description: 'Use Eureka Forbes App/Website to book service request for emergency',
      },
      // {
      //   id: 'benefit_2',
      //   icon: 'service',
      //   title: '3 service visits for maintenance',
      //   description:
      //     'Get 3 free service visits every year to ensure comprehensive cleaning and maintenance of water purifier and filters',
      // },
      {
        id: 'benefit_3',
        icon: 'consumables',
        title: 'Annual all filter replacement',
        description:
          'All filters get replaced free of charge, every year for continued purity assurance',
      },
      {
        id: 'benefit_4',
        icon: 'spares',
        title: 'Replacement of spare parts',
        description:
          'On breakdown, damaged parts shall be replaced with new spare parts free of charge',
      },
      {
        id: 'benefit_5',
        icon: 'peaceOfMind',
        title: 'Assurance of quality',
        description:
          'Get genuine Eureka Forbes filters/spare parts and stay safe from fake filters',
      },
    ],
  },
  SILVER: {
    webBenefits: [
      {
        id: 1,
        desc: 'Unlimited service visits for breakdown',
        icon: 'breakdown',
      },
      {
        id: 2,
        desc: '2 service visits for maintenance ',
        icon: 'service',
      },
      {
        id: 3,
        desc: 'Annual limited filter replacement',
        icon: 'consumables',
      },
      {
        id: 4,
        desc: '10% discount on spare parts',
        icon: 'spares',
      },
    ],
    mobileBenefits: {
      RO: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visits every year to ensure adequate cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '2',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: { title: 'Annual filter replacement**', subtitle: 'RO Membrane' },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: '50% Discount',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Sediment Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: '10% Discount',
        },
      ],
      UV: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visits every year to ensure adequate cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '2',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: { title: 'Annual filter replacement**', subtitle: 'Sediment Filter' },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: 'Free',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'UV System Check' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: '10% Discount',
        },
      ],
    },
    cartBenefits: [
      {
        id: 'benefit_1',
        icon: 'breakdown',
        title: 'Unlimited service visits for breakdown',
        description: 'Use Eureka Forbes App/Website to book service request for emergency',
      },
      // {
      //   id: 'benefit_2',
      //   icon: 'service',
      //   title: '2 service visits for maintenance',
      //   description:
      //     'Get 2 free service visits every year to ensure adequate cleaning and maintenance of water purifier and filters',
      // },
      {
        id: 'benefit_3',
        icon: 'consumables',
        title: 'Annual limited filter replacement',
        description:
          'Limited filters get replaced free of charge every year. Also get 50% discount on RO filter',
      },
      {
        id: 'benefit_4',
        icon: 'spares',
        title: 'Replacement of spare parts',
        description: 'Get 10% discount on spare parts',
      },
      {
        id: 'benefit_5',
        icon: 'peaceOfMind',
        title: 'Assurance of quality',
        description:
          'Get genuine Eureka Forbes filters/spare parts and stay safe from fake filters',
      },
    ],
  },
  VALUE: {
    webBenefits: [
      {
        id: 1,
        desc: 'Unlimited service visits for breakdown',
        icon: 'breakdown',
      },
      {
        id: 2,
        desc: '1 service visit for maintenance',
        icon: 'service',
      },
      {
        id: 3,
        desc: '25% discount on filters',
        icon: 'consumables',
      },
      {
        id: 4,
        desc: 'Replacement of spare parts at MRP',
        icon: 'spares',
      },
    ],
    mobileBenefits: {
      RO: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visit every year for cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '1',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: { title: 'Annual filter replacement**', subtitle: 'RO Membrane' },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: '25% Discount',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Sediment Filter' },
          description: '',
          icon: '',
          value: '25% Discount',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: '25% Discount',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: '25% Discount',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: 'At MRP',
        },
      ],
      UV: [
        {
          id: 'amc_benefit_1',
          category: { title: 'Unlimited service visits for breakdown', subtitle: '' },
          description: 'Use Eureka Forbes App/Website to book service request for emergency',
          icon: 'breakdown',
          value: 'Free',
        },
        {
          id: 'amc_benefit_2',
          category: { title: 'Service visits for maintenance', subtitle: '' },
          description:
            'Get free service visit every year for cleaning and maintenance of water purifier and filters',
          icon: 'service',
          value: '1',
        },
        {
          id: 'amc_benefit_3',
          displayOrder: 1,
          category: { title: 'Annual filter replacement**', subtitle: 'Sediment Filter' },
          description: 'Filters get replaced every year for continued purity assurance',
          icon: 'consumables',
          value: '25% Discount',
        },
        {
          id: 'amc_benefit_4',
          displayOrder: 2,
          category: { title: '', subtitle: 'Pre Carbon Filter' },
          description: '',
          icon: '',
          value: '25% Discount',
        },
        {
          id: 'amc_benefit_5',
          displayOrder: 3,
          category: { title: '', subtitle: 'Active Copper Filter' },
          description: '',
          icon: '',
          value: '25% Discount',
        },
        {
          id: 'amc_benefit_6',
          displayOrder: 4,
          category: { title: '', subtitle: 'UV System Check' },
          description: '',
          icon: '',
          value: 'Free',
        },
        {
          id: 'amc_benefit_7',
          category: { title: 'Replacement of spare parts', subtitle: '' },
          description: 'On breakdown, damaged parts shall be replaced with new spare parts',
          icon: 'spares',
          value: 'At MRP',
        },
      ],
    },
    cartBenefits: [
      {
        id: 'benefit_1',
        icon: 'breakdown',
        title: 'Unlimited service visits for breakdown',
        description: 'Use Eureka Forbes App/Website to book service request for emergency',
      },
      // {
      //   id: 'benefit_2',
      //   icon: 'service',
      //   title: '1 service visit for maintenance',
      //   description:
      //     'Get 1 free service visit every year for cleaning and maintenance of water purifier and filters',
      // },
      {
        id: 'benefit_3',
        icon: 'consumables',
        title: 'Annual filter replacement',
        description: 'Get 25% discount on all filters',
      },
      {
        id: 'benefit_4',
        icon: 'spares',
        title: 'Replacement of spare parts',
        description: 'At MRP',
      },
      {
        id: 'benefit_5',
        icon: 'peaceOfMind',
        title: 'Assurance of quality',
        description:
          'Get genuine Eureka Forbes filters/spare parts and stay safe from fake filters',
      },
    ],
  },
  COMPREHENSIVE: {
    webBenefits: [
      {
        id: 1,
        desc: 'Unlimited service visits for breakdown',
        icon: 'breakdown',
      },
      {
        id: 2,
        desc: 'Service visits for maintenance',
        icon: 'service',
      },
      {
        id: 3,
        desc: 'Annual all filter replacement',
        icon: 'consumables',
      },
      {
        id: 4,
        desc: 'Replacement of spare parts',
        icon: 'spares',
      },
      {
        id: 5,
        desc: 'Assurance of quality',
        icon: 'peaceOfMind',
      },
    ],
    mobileBenefits: { RO: [], UV: [] },
    cartBenefits: [
      {
        id: 'benefit_1',
        icon: 'breakdown',
        title: 'Unlimited service visits for breakdown',
        description: 'Use Eureka Forbes App/Website to book service request for emergency',
      },
      // {
      //   id: 'benefit_2',
      //   icon: 'service',
      //   title: '2 service visits for maintenance',
      //   description:
      //     'Get 2 free service visits every year to ensure comprehensive cleaning and maintenance of water purifier and filters',
      // },
      {
        id: 'benefit_3',
        icon: 'consumables',
        title: 'Annual all filter replacement',
        description:
          'All filters get replaced free of charge, every year for continued purity assurance',
      },
      {
        id: 'benefit_4',
        icon: 'spares',
        title: 'Replacement of spare parts',
        description:
          'On breakdown, damaged parts shall be replaced with new spare parts free of charge',
      },
      {
        id: 'benefit_5',
        icon: 'peaceOfMind',
        title: 'Assurance of quality',
        description:
          'Get genuine Eureka Forbes filters/spare parts and stay safe from fake filters',
      },
    ],
  },
  IN_WARRANTY: {
    cartBenefits: [
      {
        id: 'benefit_1',
        icon: 'breakdown',
        title: 'Unlimited service visits for breakdown',
        description: 'Use Eureka Forbes App/Website to book service request for emergency',
      },
      // {
      //   id: 'benefit_2',
      //   icon: 'service',
      //   title: '2 service visits for maintenance',
      //   description:
      //     'Get 2 free service visits every year to ensure comprehensive cleaning and maintenance of water purifier and filters',
      // },
      {
        id: 'benefit_3',
        icon: 'spares',
        title: 'Replacement of spare parts',
        description:
          'On breakdown, damaged parts shall be replaced with new spare parts free of charge',
      },
      {
        id: 'benefit_4',
        icon: 'peaceOfMind',
        title: 'Assurance of quality',
        description:
          'Get genuine Eureka Forbes filters/spare parts and stay safe from fake filters',
      },
    ],
  },
};
